import { denormalize } from 'normalizr';
import { sort } from 'ramda';
import reduceReducers from 'reduce-reducers';

import { createEntitiesReducer } from 'modules/common/redux';

import { createAlphabeticalComparator } from 'utils/helpers';

import { types } from './actions';
import { profitItemDefSchema } from './entities';

const initialState = {
  profitItemDefIds: [],
  entities: {},
  isCreating: false,
  isCreateModalOpen: false,
};

const entitiesReducer = createEntitiesReducer(
  ['profitItemDefs'],
  [types.CREATE_PROFIT_ITEM_SUCCESS, types.RECEIVE_PROFIT_ITEM_DEFINITIONS],
);

const reducer = (state, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CREATE_PROFIT_ITEM_ERROR:
      return {
        ...state,
        isCreating: false,
      };
    case types.CREATE_PROFIT_ITEM_REQUEST:
      return {
        ...state,
        isCreating: true,
      };
    case types.CREATE_PROFIT_ITEM_SUCCESS:
      return {
        ...state,
        profitItemDefIds: [...state.profitItemDefIds, payload.result],
        isCreating: false,
        isCreateModalOpen: false,
      };
    case types.NEW_PROFIT_ITEM_MODAL_CLOSE:
      return {
        ...state,
        isCreateModalOpen: false,
      };
    case types.NEW_PROFIT_ITEM_MODAL_OPEN:
      return {
        ...state,
        isCreateModalOpen: true,
      };
    case types.RECEIVE_PROFIT_ITEM_DEFINITIONS:
      return {
        ...state,
        profitItemDefIds: payload.result,
      };
    default:
      return state;
  }
};

export default reduceReducers(entitiesReducer, reducer, initialState);

export const getScope = (state) => state.modules.profitItems.listPage;

export const getIsCreating = (state) => getScope(state).isCreating;

export const getIsCreateModalOpen = (state) =>
  getScope(state).isCreateModalOpen;

export const getProfitItemDefs = (state) => {
  const denormalizedProfitItemDefs = denormalize(
    getScope(state).profitItemDefIds,
    [profitItemDefSchema],
    getScope(state).entities,
  );
  return sort(createAlphabeticalComparator('name'), denormalizedProfitItemDefs);
};

export const isCreating = (state) => getScope(state).isCreating;

export const isCreateModalOpen = (state) => getScope(state).isCreateModalOpen;
